import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Users, Heart, Star } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-6">
      <div className="max-w-7xl mx-auto" data-id="element-7">
        {/* Header */}
        <div className="mb-16" data-id="element-8">
          <div className="flex items-center gap-3 mb-4" data-id="element-9">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-10" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-11">
              Досьє · Про нас
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest" data-id="element-12">
            Наша місія
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-13">
          {/* Left Column - Story */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="lg:col-span-7 space-y-6" data-id="element-14">
            <div className="font-['JetBrains_Mono'] text-xs text-zinc-500 tracking-widest uppercase" data-id="element-15">
              FILE-001 / Слово засновників
            </div>

            <h3 className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-wide leading-tight text-white" data-id="element-16">
              Створено ветеранами.
              <br data-id="element-17" />
              <span className="text-[#6B7A4A]" data-id="element-18">Працюємо з дисципліною.</span>
            </h3>

            <div className="space-y-5 text-zinc-400 text-base leading-relaxed font-['Inter'] max-w-2xl" data-id="element-19">
              <p data-id="element-20">
                WIN CODE GARAGE заснували українські ветерани, які перенесли
                цінності фронту до майстерні: точність, відповідальність і
                абсолютну чесність у спілкуванні з клієнтом.
              </p>
              <p data-id="element-21">
                Кожна робота фіксується, кожна кошторисна позиція прозора. Ми не
                нав'язуємо зайвого, не зрізаємо кутів і не ховаємося за
                технічним жаргоном. Якщо ми взялися — виконаємо у строк, за
                стандартом і з гарантією на результат.
              </p>
              <p data-id="element-22">
                Наші майстри сертифіковані, процеси задокументовані, а клієнти
                для нас — побратими. Це той рівень, на якому ми працюємо.
              </p>
            </div>

            {/* Tactical values list */}
            <div className="grid grid-cols-2 gap-x-8 gap-y-4 pt-6 max-w-xl" data-id="element-23">
              {[{
              code: '01',
              label: 'Дисципліна'
            }, {
              code: '02',
              label: 'Чесність'
            }, {
              code: '03',
              label: 'Точність'
            }, {
              code: '04',
              label: 'Відданість'
            }].map(val => <div key={val.code} className="flex items-center gap-3 border-l-2 border-[#6B7A4A] pl-3 py-1" data-id="element-24">
                  <span className="font-['JetBrains_Mono'] text-xs text-zinc-600" data-id="element-25">
                    {val.code}
                  </span>
                  <span className="font-['Oswald'] text-sm uppercase tracking-widest text-white" data-id="element-26">
                    {val.label}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column - Community Impact Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} className="lg:col-span-5" data-id="element-27">
            <div className="relative bg-neutral-900/50 border border-white/10 p-8" data-id="element-28">
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A]" data-id="element-29" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A]" data-id="element-30" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A]" data-id="element-31" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A]" data-id="element-32" />

              <div className="mb-8" data-id="element-33">
                <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-34">
                  Брифінг / Підтримка ЗСУ
                </div>
                <h3 className="font-['Oswald'] text-2xl font-bold text-white uppercase tracking-wide leading-tight" data-id="element-35">
                  Поруч із
                  <br data-id="element-36" />
                  <span className="text-[#6B7A4A]" data-id="element-37">нашими захисниками</span>
                </h3>
              </div>

              <div className="space-y-5" data-id="element-38">
                <div className="flex items-start gap-4" data-id="element-39">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-40">
                    <Shield className="w-4 h-4 text-[#6B7A4A]" data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-43">
                      Пріоритет для ЗСУ
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-44">
                      Чинні військовослужбовці отримують пріоритетний запис і
                      знижку на всі види ремонту.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-45">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-46">
                    <Users className="w-4 h-4 text-[#6B7A4A]" data-id="element-47" />
                  </div>
                  <div data-id="element-48">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-49">
                      Робота для ветеранів
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-50">
                      Понад 60% нашої команди — ветерани. Проводимо навчання й
                      адаптацію тих, хто повертається з фронту.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-51">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-52">
                    <Heart className="w-4 h-4 text-[#6B7A4A]" data-id="element-53" />
                  </div>
                  <div data-id="element-54">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-55">
                      Внесок у громаду
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-56">
                      Частина кожного замовлення йде на реабілітацію ветеранів і
                      підтримку їхніх родин.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10 grid grid-cols-3 gap-4" data-id="element-57">
                <div data-id="element-58">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A]" data-id="element-59">
                    60%
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-60">
                    Ветерани в команді
                  </div>
                </div>
                <div data-id="element-61">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A]" data-id="element-62">
                    -20%
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-63">
                    Знижка для ЗСУ
                  </div>
                </div>
                <div data-id="element-64">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A] flex items-center gap-1" data-id="element-65">
                    <Star className="w-5 h-5 fill-[#6B7A4A]" data-id="element-66" />
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-67">
                    Пріоритетний запис
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}